import { Injectable } from '@angular/core';
import { Actions } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { v4 } from 'uuid';
import { onActions } from '../../utils/helpers/redux.helper';
import {
  ActionsEnum,
  exportData,
  exportExpenseReportData,
} from './export-data.actions';
import { ExportTypesEnum } from './export-data.data';

@Injectable()
export class ExportDataDispatcher {
  constructor(private _store: Store<any>, private _actions: Actions) {}

  exportData(
    exportType: ExportTypesEnum,
    userEmail: string,
    companyName: string
  ): Observable<any> {
    const dispatchId = v4();

    this._store.dispatch(
      exportData(dispatchId, exportType, userEmail, companyName)
    );

    return onActions(
      this._actions,
      [ActionsEnum.EXPORT_DATA_SUCCESS, ActionsEnum.EXPORT_DATA_ERROR],
      dispatchId
    );
  }

  expenseReportExportData(userEmail: string, taxYear: number) {
    const dispatchId = v4();

    this._store.dispatch(
      exportExpenseReportData(dispatchId, userEmail, taxYear)
    );

    return onActions(
      this._actions,
      [
        ActionsEnum.EXPORT_EXPENSE_REPORT_DATA_SUCCESS,
        ActionsEnum.EXPORT_EXPENSE_REPORT_DATA_ERROR,
      ],
      dispatchId
    );
  }
}
